Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var _reactNativeSafeAreaContext = require("react-native-safe-area-context");
var _Icon = require("../Button/Label/styles/useTypeStyles/Icon");
var useStyles = exports.useStyles = function useStyles() {
  var hasCloseCallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    box = _STYLES$useStyles.box,
    COLORS = _STYLES$useStyles.COLORS,
    colors = _STYLES$useStyles.colors,
    bp = _STYLES$useStyles.bp,
    spacing = _STYLES$useStyles.spacing;
  var insets = (0, _reactNativeSafeAreaContext.useSafeAreaInsets)();
  var _useIcon = (0, _Icon.useIcon)(),
    iconSizes = _useIcon.sizes;
  var _closeIconTopRight = spacing.s;
  var _contentPaddingTop = hasCloseCallback ? _reactNative.Platform.OS === 'web' ? "calc(".concat((0, _styles.getREM)(iconSizes.small), " + (").concat(_closeIconTopRight, " * 2))") : (0, _styles.getREM)(iconSizes.small) + _closeIconTopRight * 2 : spacing.xxxl;
  var imageContainer = {
    marginBottom: spacing.normal,
    width: '100%',
    height: 120
  };
  if (bp.not([bp.mobile_xs, bp.mobile_s, bp.mobile_normal])) {
    imageContainer.height = 140;
  }
  if (bp.is([bp.tablet, bp.desktop])) {
    imageContainer.height = 180;
    imageContainer.marginBottom = spacing.xl;
  }
  var background = {
    flexGrow: 1,
    backgroundColor: COLORS.mushroom,
    paddingTop: _reactNative.Platform.OS === 'web' ? spacing.normal : spacing.normal + insets.top,
    paddingRight: _reactNative.Platform.OS === 'web' ? spacing.normal : spacing.normal + insets.right,
    paddingBottom: _reactNative.Platform.OS === 'web' ? spacing.normal : spacing.normal + insets.bottom,
    paddingLeft: _reactNative.Platform.OS === 'web' ? spacing.normal : spacing.normal + insets.left,
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden'
  };
  if (bp.is([bp.tablet, bp.desktop])) {
    background.paddingRight = _reactNative.Platform.OS === 'web' ? spacing.xxxl : spacing.xxxl + insets.right;
    background.paddingLeft = _reactNative.Platform.OS === 'web' ? spacing.xxxl : spacing.xxxl + insets.left;
  }
  var closeButtonContainer = {
    marginTop: spacing.normal
  };
  var closeIconContainer = {
    position: 'absolute',
    zIndex: 0,
    top: _closeIconTopRight,
    right: _closeIconTopRight
  };
  var closeIcon = {
    borderColor: COLORS.aubergine
  };
  var styles = _reactNative.StyleSheet.create({
    container: Object.assign({}, _reactNative.StyleSheet.absoluteFillObject),
    background: background,
    contentContainer: {
      width: '100%',
      alignItems: 'center',
      flexDirection: 'row',
      zIndex: 1,
      position: 'relative',
      height: '100%'
    },
    content: {
      width: '100%',
      marginLeft: 'auto',
      marginRight: 'auto',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100%',
      maxWidth: _styles.STYLES.grid.maxContentWidth,
      paddingTop: _contentPaddingTop
    },
    card: Object.assign({}, box, {
      backgroundColor: colors.background,
      paddingTop: _contentPaddingTop,
      paddingBottom: spacing.xxxl,
      paddingLeft: spacing.xl,
      paddingRight: spacing.xl,
      borderRadius: (0, _styles.getREM)(1.25),
      flexBasis: '100%',
      minHeight: 0,
      maxWidth: _styles.STYLES.grid.maxContentWidth
    }),
    image: {
      width: '100%',
      height: '100%'
    },
    imageContainer: imageContainer,
    title: {
      textAlign: 'center'
    },
    textContainer: {
      textAlign: 'center',
      maxWidth: _styles.STYLES.grid.maxTextWidth,
      alignSelf: 'center',
      marginBottom: spacing.xl
    },
    closeButtonContainer: closeButtonContainer,
    closeIconContainer: closeIconContainer,
    closeIcon: closeIcon
  });
  return {
    styles: styles
  };
};